"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_INITIAL_DEVICE_DATA = exports.SET_ALARM_ITEM = exports.SET_ACTIVE_PWH_C = exports.SET_ACTIVE_GROUP = exports.SET_ACTIVE_BUILDING = exports.RESET_ALL = void 0;
const SET_ACTIVE_BUILDING = exports.SET_ACTIVE_BUILDING = 'SET_ACTIVE_BUILDING_P_T_CARDS';
const SET_ACTIVE_PWH_C = exports.SET_ACTIVE_PWH_C = 'SET_ACTIVE_PWH_C_P_T_CARDS';
const SET_ACTIVE_GROUP = exports.SET_ACTIVE_GROUP = 'SET_ACTIVE_GROUP';
const SET_INITIAL_DEVICE_DATA = exports.SET_INITIAL_DEVICE_DATA = 'SET_INITIAL_DEVICE_DATA';
const SET_ALARM_ITEM = exports.SET_ALARM_ITEM = 'SET_ALARM_ITEM';
const RESET_ALL = exports.RESET_ALL = 'RESET_ALL_P_T_CARDS';